var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",attrs:{"id":"top"}},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"base_image",attrs:{"src":require("@/assets/image/common/logo_background.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }